import consumer from "./consumer"

const searchChannels = new Map();

export function subscribeToSearch(searchId, callbacks = {}) {
  // Don't create duplicate subscriptions
  if (searchChannels.has(searchId)) {
    return searchChannels.get(searchId);
  }

  const subscription = consumer.subscriptions.create(
    { channel: "SearchChannel", search_id: searchId },
    {
      connected() {
        console.log(`Connected to search ${searchId}`);
        if (callbacks.onConnected) callbacks.onConnected();
      },

      disconnected() {
        console.log(`Disconnected from search ${searchId}`);
        searchChannels.delete(searchId);
        if (callbacks.onDisconnected) callbacks.onDisconnected();
      },

      received(data) {
        console.log("Received search update:", data);
        
        if (data.status === 'completed' && data.redirect_url) {
          if (callbacks.onCompleted) {
            callbacks.onCompleted(data);
          } else {
            // Default behavior: redirect to the search page
            window.location.href = data.redirect_url;
          }
        } else if (data.status === 'failed') {
          if (callbacks.onFailed) {
            callbacks.onFailed(data);
          } else {
            // Default behavior: show error
            alert(`Search failed: ${data.error || data.message}`);
          }
        }

        if (callbacks.onUpdate) {
          callbacks.onUpdate(data);
        }
      }
    }
  );

  searchChannels.set(searchId, subscription);
  return subscription;
}

export function unsubscribeFromSearch(searchId) {
  const subscription = searchChannels.get(searchId);
  if (subscription) {
    subscription.unsubscribe();
    searchChannels.delete(searchId);
  }
}